<template>
  <main class="container main-location-list">
    <section class="main-location-list-1">
      <h1 class="title">Where is <br class="mo_show" />CESCO needed?</h1>
      <p class="description">Providing the optimal solution for <br class="mo_show" />each location.</p>

      <div class="location-list">
        <div class="location-card">
          <router-link to="/solution/place/home">
            <img src="@/assets/images/location/list/location_list_01.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Homes</h3>
          </router-link>
        </div>
        <div class="location-card">
          <router-link to="/solution/place/restaurant">
            <img src="@/assets/images/location/list/location_list_02.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Dining Establishments</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/retail">
            <img src="@/assets/images/location/list/location_list_03.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Distribution Facilities</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/edu">
            <img src="@/assets/images/location/list/location_list_04.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Educational Facilities</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/building">
            <img src="@/assets/images/location/list/location_list_05.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Building</h3>
          </router-link>
        </div>
        <div class="location-card">
          <router-link to="/solution/place/service">
            <img src="@/assets/images/location/list/location_list_06.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Service Facilities</h3>
          </router-link>
        </div>
        <div class="location-card">
          <router-link to="/solution/place/culture">
            <img src="@/assets/images/location/list/location_list_07.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Cultural Facilities</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/medical">
            <img src="@/assets/images/location/list/location_list_08.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Medical Facilities</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/hotel">
            <img src="@/assets/images/location/list/location_list_09.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Hotel</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/motel">
            <img src="@/assets/images/location/list/location_list_10.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Motel</h3>
          </router-link>
        </div>
        <div class="location-card">
          <router-link to="/solution/place/foodfactory">
            <img src="@/assets/images/location/list/location_list_11.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Food Manufacturing</h3>
          </router-link>
        </div>
        <div class="location-card">
          <router-link to="/solution/place/factory">
            <img src="@/assets/images/location/list/location_list_12.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Manufacturing Plant</h3>
          </router-link>
        </div>

        <div class="location-card">
          <router-link to="/solution/place/storage">
            <img src="@/assets/images/location/list/location_list_13.png" alt="CESCO [BusinessSectors] Where is CESCO needed?" />
            <h3>Warehouse</h3>
          </router-link>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { useMeta } from 'vue-meta'

useMeta({
  title: 'CESCO - Where is CESCO needed?',
  meta: [
    {
      name: 'description',
      content: 'Where is CESCO needed? Providing the optimal solution for each location.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
